<template>
	<span v-if="isWithoutClass" class="flex justify-center items-center text-white mr-3">
		<SvgIcon v-if="icon === 'close'" :width="width" :height="height" icon="close" />
		<SvgIcon v-else-if="icon === 'back'" classes="h-5 w-5 icon-color" icon="back" />
	</span>
	<span v-else class="flex justify-center items-center" :class="[colorClass, parentClass]">
		<SvgIcon v-if="icon === 'close'" :width="width" :height="height" icon="close" />
		<SvgIcon v-else-if="icon === 'back'" classes="h-5 w-5" icon="back" />
	</span>
</template>

<script>
import SvgIcon from './SvgIcon';
export default {
	name: 'Close',
	components: { SvgIcon },
	props: {
		icon: {
			type: String,
		},
		colorClass: {
			type: String,
			default: 'text-text',
		},
		parentClass: {
			type: String,
			default: 'close-btn',
		},
		width: {
			type: String,
			default: "16px"
		},
		height: {
			type: String,
			default: "16px"
		},
		isWithoutClass: {
			type: Boolean,
			default: false
		}
	},

	data: function () {
		return {};
	},
};
</script>
